export const HERO_TITLE = 'Schedule'
export const HERO_SUBTITLE =
  "Keep up to date with your team's schedule, roster, and stats"
